import React from 'react';
import TenantMobileLayout from './TenantMobileLayout';
import MenuPage from '../../pages/MenuPage';

const TenantMobileMenu = ({ onBack }) => {
  return (
    <TenantMobileLayout title="Menu" onBack={onBack}>
      <div className="mobile-content-wrapper">
        <MenuPage />
      </div>
    </TenantMobileLayout>
  );
};

export default TenantMobileMenu;
